module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "xbigspace"
  }), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("Dedicated")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("to")]), _vm._v(" "), _c('p', {
    staticClass: "xxsmallspace"
  }), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("MARY QUEEN OF THE HOLY ROSARY")]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("Gracious Patroness of the United States")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("in humble petition")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("that")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("through thy Immaculate Heart")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("the world may find its way back to")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("the Sacred Heart of thy Divine Son")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "imgsecimage.png",
      "src": "html/docimages/imgsecimage.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fab49580","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_dedication.vue
// module id = 69
// module chunks = 0